import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/**
 * Returns a class that extends the Fetcher class to handle DynamoDB pagination.
 *
 * @param {Function} Fetcher - The Fetcher class to extend
 * @param {Object.<string, any>} optionalParams - Optional query parameters to pass to the request
 * @returns {Function} - A new class that extends Fetcher with pagination capabilities
 */
export function withDynamoPagination(Fetcher) {
  var optionalParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/function (_Fetcher) {
    function _class() {
      var _this2;
      _classCallCheck(this, _class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this2 = _callSuper(this, _class, [].concat(args));
      // just pass thru the entire fetch Response object
      _this2.asyncResponseHandler = function (response) {
        return response;
      };
      return _this2;
    }
    _inherits(_class, _Fetcher);
    return _createClass(_class, [{
      key: "paginatedGet",
      value: function () {
        var _paginatedGet = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
          var _this3 = this;
          var _ref,
            actionCreator,
            lastEvaluatedHashKey,
            lastEvaluatedRangeKey,
            responses,
            ancillary,
            response,
            resolvedResponses,
            _args = arguments;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, actionCreator = _ref.actionCreator;
                responses = [];
                ancillary = [];
              case 3:
                _context.next = 5;
                return this.get(url, _objectSpread({
                  lastEvaluatedHashKey: lastEvaluatedHashKey,
                  lastEvaluatedRangeKey: lastEvaluatedRangeKey
                }, optionalParams));
              case 5:
                response = _context.sent;
                responses.push(response);

                // we handle the json parsing and dispatching asynchronously so that
                // we can keep making network requests until pagination is exhausted
                ancillary.push(actionCreator ? response.json().then(function (json) {
                  return _this3.dispatch(actionCreator(json));
                }) : response.json());
                lastEvaluatedHashKey = response.headers.get('X-Last-Evaluated-Hash-Key');
                lastEvaluatedRangeKey = response.headers.get('X-Last-Evaluated-Range-Key');
              case 10:
                if (lastEvaluatedHashKey && lastEvaluatedRangeKey) {
                  _context.next = 3;
                  break;
                }
              case 11:
                _context.next = 13;
                return Promise.all(ancillary);
              case 13:
                resolvedResponses = _context.sent;
                if (!actionCreator) {
                  _context.next = 18;
                  break;
                }
                return _context.abrupt("return", responses);
              case 18:
                return _context.abrupt("return", resolvedResponses.reduce(function (res, acc) {
                  return [].concat(_toConsumableArray(res), _toConsumableArray(acc));
                }, []));
              case 19:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function paginatedGet(_x) {
          return _paginatedGet.apply(this, arguments);
        }
        return paginatedGet;
      }()
    }]);
  }(Fetcher);
}
export default withDynamoPagination;